import React from "react";
import Button from "../../components/ui/Button";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Icon from "../../components/AppIcon";

const TransactionHistory = ({ size = "default" }) => {
  const { t } = useTranslation();

  const { ordersList } = useSelector((state) => state.orders);

  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case "not_confirmed":
        return {
          label: t("not_confirmed"),
          icon: "Clock",
          bgColor: "bg-warning/10",
          textColor: "text-warning",
          borderColor: "border-warning/20",
        };
      case "in_progress":
        return {
          label: t("processing"),
          icon: "Loader",
          bgColor: "bg-primary/10",
          textColor: "text-primary",
          borderColor: "border-primary/20",
        };
      case "shipped":
        return {
          label: t("shipped"),
          icon: "Truck",
          bgColor: "bg-accent/10",
          textColor: "text-accent",
          borderColor: "border-accent/20",
        };
      case "delivered":
        return {
          label: t("delivered"),
          icon: "CheckCircle",
          bgColor: "bg-success/10",
          textColor: "text-success",
          borderColor: "border-success/20",
        };
      case "cancelled":
        return {
          label: t("cancelled"),
          icon: "XCircle",
          bgColor: "bg-error/10",
          textColor: "text-error",
          borderColor: "border-error/20",
        };
      default:
        return {
          label: "Unknown",
          icon: "HelpCircle",
          bgColor: "bg-muted",
          textColor: "text-muted-foreground",
          borderColor: "border-border",
        };
    }
  };

  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    default: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  const iconSizes = {
    sm: 12,
    default: 14,
    lg: 16,
  };

  return (
    <section className="flex flex-col w-full lg:w-[70%] bg-background-card rounded-base shadow-[0px_1px_3px_#00000033] p-5">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-5">
        <h3 className="text-lg font-bold text-text-accent">
          {t("transaction")}
        </h3>
      </div>
      {/* Table */}
      <div className="w-full overflow-x-auto">
        <table className="w-full text-sm text-gray-700">
          <thead className="bg-green-50 text-green-900 font-semibold">
            <tr className="border-b border-border-secondary">
              <th className="text-center text-base font-medium text-[#7c7c7c] py-2"></th>
              <th className="text-center text-base font-medium text-[#7c7c7c] py-2">
                {t("customer")}
              </th>
              <th className="text-center text-base font-medium text-[#7c7c7c] py-2">
                {t("order_date")}
              </th>
              <th className="text-center text-base font-medium text-[#7c7c7c] py-2">
                {t("status")}
              </th>
              <th className="text-center text-base font-medium text-[#7c7c7c] py-2">
                {t("amount")}
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {ordersList?.map((transaction, index) => {
              const config = getStatusConfig(transaction?.status);
              return (
                <tr key={transaction?.id} className="border-b border-gray-100">
                  <td className="text-base font-medium text-text-primary py-3 pl-6">
                    {index + 1}.
                  </td>
                  <td className="text-center  text-base font-medium text-text-primary py-3">
                    {transaction?.first_name} {transaction?.last_name}
                  </td>
                  <td className="text-center text-base font-medium text-text-primary py-3">
                    {transaction?.created_at
                      ? new Date(transaction.created_at)
                          .toISOString()
                          .slice(0, 10)
                      : ""}
                  </td>
                  <td className="py-3">
                    <div
                      className={`inline-flex items-center space-x-1.5 rounded-full border font-medium ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses[size]}`}
                    >
                      <Icon
                        name={config.icon}
                        size={iconSizes[size]}
                        className={` ${config.textColor} ${
                          status === "processing" ? "animate-spin" : ""
                        }`}
                      />
                      <span className="px-2">{config.label}</span>
                    </div>
                  </td>
                  <td className="text-center  text-base font-medium text-text-primary py-3">
                    {transaction?.total_price}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default TransactionHistory;
